import ManageTableColumnsPage from './ManageTableColumnsPage';

export default ManageTableColumnsPage;
